import React, { Component } from "react";
import { API_URL } from "src/scenes/App";
import axios from "axios";
import styled from "styled-components";
import {
    LottieLoadingIndicator, ErrorText, Form,
    FlexContainer
} from "src/components";
import ClientLicenseModal from "../components/ClientLicenseModal";
import InviteSentModal from "../components/InviteSentModal";
import InviteSent from "../components/InviteSent";
import { StyledInput, StyledLabel } from "src/components/AppInvite/MultipleInvitesForm";
import AppInviteMethod from "src/components/AppInviteMethod";
import { Divider } from "@mui/material";

const ContainerGrid = styled.div`
    display: grid;
    grid-template-columns: 47% 47%;
    grid-template-rows: auto;
    column-gap: 6%;
    row-gap: 8%;
`;

const ActionButtonContainer = styled.div`
    margin-top: -2.5rem;
`;

const ActionButton = styled.button`
    cursor: pointer;
    border-radius: 7px !important;
    color: ${ p => (p.color) || "#000" };
    background-color: ${ p => (p.backgroundColor) || "#fff" };
    font-size:14px;
    border: ${ p => (p.border) || "1px solid #000" };
    padding: ${ p => (p.padding) || "10px 45px 10px !important" };
`;
class SendRenewalForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            licenseEmployee: {
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                department: "",
                licenseDuration: "",
                startDate: "",
                licenseStatus: "notStarted" //use to disable input fields and remove client button
            },
            isFormSubmitted: false,
            checkedEmailInvite: props.isEmailSelected,
            checkedSmsInvite: props.isSmsSelected,

            emailInviteInProgress: false,
            smsInviteInProgress: false,

            isEmailSentSuccessful: false,
            isSmsSentSuccessful: false,

            smsInviteCompleted: false,
            emailInviteCompleted: false,

            smsResponseMessage: "",
            emailResponseMessage: "",

            showSentModal: false,

            sendInvitationErrorString: "",

            inviteMethod: "email"
        };
    }

    componentDidMount() {
        this.safeToInit();
    }

    safeToInit = () => {
        this.populateClientLicenseForm();
    };

    populateClientLicenseForm = () => {
        const { selectedLicenseEmployee } = this.props;
        this.setState(prevState => ({
            responseErrors: [],
            licenseEmployee: selectedLicenseEmployee     
        }));
    };

    componentDidUpdate(prevProps, prevState) {
    // This will be executed after the component is updated
    // You can perform any side effect here, like updating the DOM

        if (this.state.smsInviteCompleted !== prevState.smsInviteCompleted) {
            if (this.state.smsInviteCompleted && this.state.emailInviteCompleted) {
                ClientLicenseModal.close();
                this.openInviteSentModal();
            }  
        }

        if (this.state.emailInviteCompleted !== prevState.emailInviteCompleted) {
            if (this.state.smsInviteCompleted && this.state.emailInviteCompleted) {
                ClientLicenseModal.close();
                this.openInviteSentModal();
            }  
        }
        if (
            prevProps.isEmailSelected !== this.props.isEmailSelected ||
            prevProps.isSmsSelected !== this.props.isSmsSelected
        ) {
            this.setState({
                checkedEmailInvite: this.props.isEmailSelected,
                checkedSmsInvite: this.props.isSmsSelected,
            });
        }
    }

    sendSmsInvites = () => {
        if (this.state.smsInviteInProgress) {
            return;
        }

        const employeeUuid = this.props.selectedLicenseEmployee.employeeUuid;

        this.setState(state => ({
            smsInviteInProgress: true,
            smsInviteCompleted: false,
        }));

        axios({
            method: "POST",
            data: {
                sendToSms: "1", 
            },
            url: `${API_URL}/company/sendLicenseRenewalLink/` + employeeUuid,
            headers: {
                Authorization: "Bearer " + this.props.user.token
            }
        }).then((response) => {
            if (response.data.subject !== null && response.data.subject === "rate-limit") {
                this.setState(state => ({
                    isSmsSentSuccessful: false,
                    smsResponseMessage: "Sorry, you have already sent this user an SMS invitation today. You may only do that once per day.",
                }));
            } else if (response.data.isSmsSentSuccessful !== null && response.data.isSmsSentSuccessful === false) {
                this.setState(state => ({
                    isSmsSentSuccessful: false,
                    smsResponseMessage: "* There was a problem sending the SMS invite",
                }));
            } else {
                this.setState(state => ({
                    isSmsSentSuccessful: true,
                    smsResponseMessage: "",
                }));
            }
        }).catch(error => {
            this.setState(state => ({
                isSmsSentSuccessful: false,
                smsResponseMessage: "* There was a problem sending the SMS invite",
            }));
        }).finally(() => {
            this.setState(state => ({
                smsInviteInProgress: false,
                smsInviteCompleted: true
            }));
        });
    };

    sendEmailInvites = () => {
        if (this.state.emailInviteInProgress) {
            return;
        }

        const employeeUuid = this.props.selectedLicenseEmployee.employeeUuid;

        this.setState(state => ({
            emailInviteInProgress: true,
            emailInviteCompleted: false,
        }));

        axios({
            method: "POST",
            data: {
                sendToEmail: "1", 
            },
            url: `${API_URL}/company/sendLicenseRenewalLink/` + employeeUuid,
            headers: {
                Authorization: "Bearer " + this.props.user.token
            }
        }).then((response) => {
            if (response.data.subject !== null && response.data.subject === "rate-limit") {
                this.setState(state => ({
                    isEmailSentSuccessful: false,
                    emailResponseMessage: "Sorry, you have already sent this user an email invitation today. You may only do that once per day.",
                }));
            } else if (response.data.isEmailSentSuccessful !== null && response.data.isEmailSentSuccessful === false) {
                this.setState(state => ({
                    isEmailSentSuccessful: false,
                    smsResponseMessage: "* There was a problem sending the Email invite",
                }));
            } else {
                this.setState(state => ({
                    isEmailSentSuccessful: true,
                    emailResponseMessage: "",
                }));
            }
        }).catch(error => {
            this.setState(state => ({
                isEmailSentSuccessful: false,
                emailResponseMessage: "* There was a problem sending the Email invite",
            }));
        }).finally(() => {
            this.setState(state => ({
                emailInviteInProgress: false,
                emailInviteCompleted: true
            }));
        });
    };

    submitInvitationLink = () => {
        const {
            checkedEmailInvite, checkedSmsInvite, inviteMethod
        } = this.state;

        if (checkedEmailInvite === false && checkedSmsInvite === false) {
            this.setState(state => ({
                loading: false,
                sendInvitationErrorString: "* Please select at least one method for sending",
            }));

            return;
        }

        this.setState(state => ({
            isFormSubmitted: true,
            sendInvitationErrorString: "",
        }));
        
        if (inviteMethod === "email") {
            this.sendEmailInvites();
            this.setState({ smsInviteCompleted: true });
        } else if (inviteMethod === "sms") {
            this.sendSmsInvites();
            this.setState({ emailInviteCompleted: true }); 
        } else if (inviteMethod === "both") {
            this.sendSmsInvites();
            this.sendEmailInvites();
        }

        /**
         * Check ComponentDidUpdate for the continuation of this method.
         * should open a successfully sent modal depends on the response.
         */
    };

    openInviteSentModal = () => {
        const { licenseEmployee, 
            checkedEmailInvite, checkedSmsInvite, 
            smsResponseMessage, emailResponseMessage, 
            isSmsSentSuccessful, isEmailSentSuccessful
        } = this.state;
        
        let headerTitle;

        if (isEmailSentSuccessful && isSmsSentSuccessful)
            headerTitle = "License Renewal Link Sent Successfully!";
        else if (isEmailSentSuccessful || isSmsSentSuccessful)
            headerTitle = "Renewal Link Sent Successfully";
        else
            headerTitle = "Something went wrong";

        const modalHeader = <React.Fragment> {headerTitle} </React.Fragment>;
        const inviteSent = <React.Fragment> 
            <InviteSent 
                user={this.props.user} 
                licenseEmployee={licenseEmployee} 
                checkedEmailInvite={checkedEmailInvite} 
                checkedSmsInvite={checkedSmsInvite} 
                isEmailSentSuccessful={isEmailSentSuccessful} 
                isSmsSentSuccessful={isSmsSentSuccessful} 
                emailResponseMessage={emailResponseMessage}
                smsResponseMessage={smsResponseMessage}
                cancel={InviteSentModal.close}
                inviteMethod={this.state.inviteMethod}
            />
        </React.Fragment>;

        InviteSentModal.open(
            modalHeader,
            inviteSent,
            false
        );
    };

    cancel = () => {
        ClientLicenseModal.close();
    };

    checkEmailInvite = () => {
        this.setState({
            checkedEmailInvite: !this.state.checkedEmailInvite
        });
    };

    checkSmsInvite = () => {
        this.setState({
            checkedSmsInvite: !this.state.checkedSmsInvite
        });
    };

    toggleEmailInvite = () => {
        this.setState(
            (prevState) => ({ checkedEmailInvite: !prevState.checkedEmailInvite }),
            () => this.props.checkEmailInvite() 
        );
    };

    toggleSmsInvite = () => {
        this.setState(
            (prevState) => ({ checkedSmsInvite: !prevState.checkedSmsInvite }),
            () => this.props.checkSmsInvite() 
        );
    };

    handleSwitchMethod = (method) => {
        this.setState({ inviteMethod: method });
        if (this.props.setAppInviteMethod) {
            this.props.setAppInviteMethod(method);
        }
    };

    
    render() {
        const { sendInvitationErrorString, responseErrors, licenseEmployee, isFormSubmitted } = this.state;

        return (
            <>
                <Form width="100%" onSubmit={(e) => {e.preventDefault(); }} >
                    <ErrorText margin="0">
                        { responseErrors ? responseErrors : null }  
                    </ErrorText>

                    <React.Fragment>
                        <div style={{ width: "100%" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%", marginBottom: "3rem", gap: ".5rem" }}>
                                <div style={{ flex: "1", marginRight: "1rem" }}>
                                    <StyledLabel>Name</StyledLabel>
                                    <StyledInput value={licenseEmployee.firstName + " " + licenseEmployee.lastName} onChange={() => {}} />
                                </div>

                                <div style={{ flex: "1", marginRight: "1rem" }}>
                                    <StyledLabel>Email</StyledLabel>
                                    <StyledInput value={licenseEmployee.email} onChange={() => {}} />
                                </div>

                                <div style={{ flex: "1" }}>
                                    <StyledLabel>Mobile</StyledLabel>
                                    <StyledInput value={licenseEmployee.phoneNumber} onChange={() => {}} />
                                </div>
                            </div>
                            <Divider style={{ width: "calc(100% + 7rem)", marginLeft: "-3.5rem" }}/>
                            <div style={{ flex: "1", marginTop: "1.5rem", }}>
                                <StyledLabel style={{ marginBottom: "0.25rem" }}>Select Method</StyledLabel>
                                <AppInviteMethod
                                    setAppInviteMethod={this.handleSwitchMethod}
                                    noTitle={true}
                                />
                            </div>

                            <ErrorText margin="0">
                                { sendInvitationErrorString.length > 0 ? sendInvitationErrorString : null }  
                            </ErrorText>
                        </div>
                    </React.Fragment>
                </Form>
            
                <ActionButtonContainer>
                    <Divider style={{ width: "100%", position: "absolute", left: 0, bottom: "80px" }}/>
                    <ContainerGrid>
                        {
                            isFormSubmitted
                                ?
                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        margin: "-2.5rem 12rem",
                                    }}
                                >
                                    <LottieLoadingIndicator height="3em" width="3em" />
                                </div>
                                :
                  
                                <div style={{ flexGrow: 1, gridColumn: "1 / span 2" }}>
                                    <FlexContainer justifyContent="space-between" alignItems="flex-end" display="flex" direction="row" tDirection="row" style={{ marginTop: "1rem", gap: "1rem" }}>
                                        <ActionButton style={{ marginLeft: "auto" }} backgroundColor="#FFFFFF" color="#000" onClick={this.cancel}>
                                            Cancel
                                        </ActionButton>
                                        <ActionButton color="#FFF" backgroundColor="#171A22" border="none" onClick={this.submitInvitationLink}>
                                            Submit
                                        </ActionButton>
                                    </FlexContainer>
                                </div>
                        }
                    </ContainerGrid>
                </ActionButtonContainer>
            </>
        );
    }
}

export default SendRenewalForm;
